export const AMBIENT_SCRIBE_FEATURE_KEY = "ambient_scribe_users";
